import React from 'react';
import { Translations } from '../i18n/translations';
import { WhatsAppIcon } from './icons';
import { Logo } from './Logo';
interface FooterProps {
  t: Translations;
  setPage: (page: 'home' | 'product') => void;
}
export const Footer: React.FC<FooterProps> = ({
  t,
  setPage
}) => {
  return <footer className="bg-ink text-cream pt-16 pb-8 px-4 lg:px-8" data-id="element-41">
      <div className="max-w-7xl mx-auto" data-id="element-42">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16" data-id="element-43">
          {/* Brand Col */}
          <div className="flex flex-col space-y-6" data-id="element-44">
            <div className="flex items-center" data-id="element-45">
              <Logo width={200} className="mb-2" data-id="element-46" />
            </div>
            <p className="text-gold text-sm tracking-widest uppercase" data-id="element-47">
              {t.footer.tagline}
            </p>
            <p className="text-cream/70 text-sm leading-relaxed max-w-xs" data-id="element-48">
              {t.footer.mission}
            </p>
            <button className="flex items-center justify-center space-x-2 border border-gold text-gold py-3 px-6 rounded-sm hover:bg-gold hover:text-ink transition-soft w-fit" data-id="element-49">
              <WhatsAppIcon className="w-5 h-5" data-id="element-50" />
              <span className="text-sm tracking-wide" data-id="element-51">WhatsApp</span>
            </button>
          </div>

          {/* Shop Col */}
          <div className="flex flex-col space-y-4" data-id="element-52">
            <h4 className="font-serif text-xl text-gold mb-2" data-id="element-53">Shop</h4>
            {[t.nav.women, t.nav.men, t.nav.accessories, t.nav.kits].map((item, i) => <button key={i} onClick={() => setPage('home')} className="text-left text-cream/70 hover:text-gold transition-colors text-sm tracking-wide w-fit" data-id="element-54">
                  {item}
                </button>)}
          </div>

          {/* Support Col */}
          <div className="flex flex-col space-y-4" data-id="element-55">
            <h4 className="font-serif text-xl text-gold mb-2" data-id="element-56">Support</h4>
            {[t.footer.shipping, t.footer.returns, t.footer.sizeGuide, t.footer.contact, t.footer.faq].map((item, i) => <button key={i} className="text-left text-cream/70 hover:text-gold transition-colors text-sm tracking-wide w-fit" data-id="element-57">
                {item}
              </button>)}
          </div>

          {/* Newsletter Col */}
          <div className="flex flex-col space-y-4" data-id="element-58">
            <h4 className="font-serif text-xl text-gold mb-2" data-id="element-59">Newsletter</h4>
            <p className="text-cream/70 text-sm leading-relaxed" data-id="element-60">
              {t.footer.newsletter}
            </p>
            <form className="flex flex-col space-y-4 mt-2" onSubmit={e => e.preventDefault()} data-id="element-61">
              <input type="email" placeholder="Email" className="bg-transparent border-b border-gold/40 py-2 text-cream placeholder-cream/40 focus:outline-none focus:border-gold transition-colors text-sm" data-id="element-62" />
              <button className="bg-gold text-ink py-3 px-6 text-sm tracking-widest uppercase hover:bg-gold-dark transition-colors rounded-sm font-medium" data-id="element-63">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gold/20 flex flex-col lg:flex-row items-center justify-between space-y-6 lg:space-y-0" data-id="element-64">
          <div className="flex items-center space-x-3" data-id="element-65">
            {['ZELLE', 'VISA', 'MASTERCARD', 'AMEX', 'PAYPAL'].map(method => <div key={method} className="border border-gold/40 rounded-sm px-2 py-1 text-[10px] tracking-widest text-gold" data-id="element-66">
                {method}
              </div>)}
          </div>
          <div className="flex flex-col lg:flex-row items-center space-y-2 lg:space-y-0 lg:space-x-6 text-xs text-cream/50 tracking-wide" data-id="element-67">
            <span data-id="element-68">© {new Date().getFullYear()} Sculpted Body.</span>
            <span data-id="element-69">{t.footer.madeIn}</span>
          </div>
        </div>
      </div>
    </footer>;
};